module.exports = __webpack_public_path__ + "static/media/Mouth-Cavity v1.b0fe7107.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Mouth-Cavity v1.png
// module id = 1178
// module chunks = 0